import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

/**
 * Loads the next page when the returned ref scrolls into view.
 *
 * Render the ref on an element at the bottom of the scroll container, only when
 * there is a next page to fetch.
 */
export function useInfiniteScrollSentinel(params: {
    hasNextPage: boolean;
    isFetchingNextPage: boolean;
    onLoadMore: () => void;
}): { ref: (node?: Element | null) => void } {
    const { hasNextPage, isFetchingNextPage, onLoadMore } = params;

    const { ref, inView } = useInView({ threshold: 0 });

    useEffect(() => {
        if (inView && hasNextPage && !isFetchingNextPage) {
            onLoadMore();
        }
    }, [inView, hasNextPage, isFetchingNextPage, onLoadMore]);

    return { ref };
}
